module.exports = __webpack_public_path__ + "static/media/jinray.089333c7.svg";